import { render, staticRenderFns } from "./news-post.vue?vue&type=template&id=2d47687c&scoped=true&"
import script from "./news-post.vue?vue&type=script&lang=js&"
export * from "./news-post.vue?vue&type=script&lang=js&"
import style0 from "./news-post.vue?vue&type=style&index=0&id=2d47687c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d47687c",
  null
  
)

export default component.exports